import { useState } from 'react';
import EventCard from './EventCard';
import Pagination from '../../../components/Pagination/Pagination';

const categories = [
   { id: 'all', name: 'All' },
   { id: 'animation', name: 'Animation' },
   { id: 'design', name: 'Design' },
   { id: 'illustration', name: 'Illustration' },
   { id: 'lifestyle', name: 'Lifestyle' },
   { id: 'photo-film', name: 'Photo & Film' },
   { id: 'business', name: 'Business' },
   { id: 'writing', name: 'Writing' },
];

const events = Array(20).fill({
   title: 'Summer School 2022',
   date: '6 April, 2022',
   location: 'London, UK',
   image: '/courses-list/1.png',
});

const EventsSection = () => {
   const [activeTab, setActiveTab] = useState('all');
   const [currentPage, setCurrentPage] = useState(1);

   const eventsPerPage = 9; // ✅ nombre de cours par page
   const totalPages = Math.ceil(events.length / eventsPerPage);
   const indexOfLastEvent = currentPage * eventsPerPage;
   const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
   const currentEvents = events.slice(indexOfFirstEvent, indexOfLastEvent);

   return (
      <section className="py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
         <div className="max-w-7xl mx-auto">
            <div className="overflow-x-auto pb-2 mb-8">
               <div className="flex flex-nowrap sm:flex-wrap justify-start sm:justify-center gap-2 w-max sm:w-full">
                  {categories.map((category) => (
                     <button
                        key={category.id}
                        className={`px-3 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-medium transition-colors duration-300 whitespace-nowrap ${activeTab === category.id
                           ? 'bg-light-3 text-purple-1 dark:bg-dark-5'
                           : 'text-gray-700 hover:bg-gray-200 dark:text-gray-200 dark:hover:bg-gray-500'
                           }`}
                        onClick={() => setActiveTab(category.id)}
                     >
                        {category.name}
                     </button>
                  ))}
               </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
               {currentEvents.map((event, index) => (
                  <EventCard key={index} event={event} />
               ))}
            </div>

            <div className="mt-8 sm:mt-12 w-full">
               <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
               />
            </div>
         </div>
      </section>
   );
};

export default EventsSection;